import { stdout } from 'node:process';
import type { Options as OraOptions } from 'ora';
import ora from 'ora';

export function createLogger() {
  return {
    log: (message: string) => {
      // eslint-disable-next-line no-console
      console.log(message);
    },
    error: (message: string) => {
      // eslint-disable-next-line no-console
      console.error(message);
    },
    logWithLoader: (messageOrOptions?: string | OraOptions) => {
      const initialOptions: OraOptions =
        typeof messageOrOptions === 'string'
          ? { text: messageOrOptions }
          : (messageOrOptions ?? {});
      const options = {
        ...initialOptions,
        discardStdin: false,
        isEnabled: true,
        stream: stdout,
      };

      const loader = ora(options).start();

      return {
        update: (message: string) => {
          loader.text = message;
        },
        succeed: (message?: string) => {
          loader.succeed(message);
        },
        info: (message?: string) => {
          loader.info(message);
        },
        warn: (message?: string) => {
          loader.warn(message);
        },
        fail: (message?: string) => {
          loader.fail(message);
        },
        stop: () => {
          loader.stop();
        },
      };
    },
  };
}

export type Logger = ReturnType<typeof createLogger>;
